/**
 * Django API base URL including the `/api` path prefix.
 *
 * Configure via VITE_API_URL (Vite, build-time). Examples:
 *   Local:      http://localhost:8000/api
 *   Production: https://api.example.com/api
 *
 * Development / test may fall back to localhost. Production builds must set
 * VITE_API_URL explicitly — there is no silent localhost fallback.
 */

function normalizeApiBase(value) {
  const trimmed = String(value || '').trim();
  if (!trimmed) return '';
  // Strip trailing slashes so `${API_BASE_URL}/v1/...` never doubles them.
  return trimmed.replace(/\/+$/, '');
}

function resolveApiBaseUrl() {
  const configured = normalizeApiBase(import.meta.env.VITE_API_URL);
  if (configured) {
    return configured;
  }
  // Vite `npm run dev` / Vitest — local Django default only.
  if (import.meta.env.DEV || import.meta.env.MODE === 'test') {
    return 'http://localhost:8000/api';
  }
  throw new Error(
    'VITE_API_URL is required for production builds. ' +
      'Example: VITE_API_URL=https://api.example.com/api npm run build'
  );
}

export const API_BASE_URL = resolveApiBaseUrl();

export default API_BASE_URL;
